"use client";

import { useSelectContext } from "../__chunks/KPEX55MY.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/LMDWO4NN.js";
import { useStoreState } from "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/select/select-value.tsx
function SelectValue() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    store = _ref.store,
    fallback = _ref.fallback,
    children = _ref.children;
  var context = useSelectContext();
  store = store || context;
  var value = useStoreState(store, function (state) {
    if (!(state == null ? void 0 : state.value.length)) return fallback;
    return state.value;
  });
  if (children) {
    return children(value || "");
  }
  return value;
}
export { SelectValue };